import React from "react";
import RouteIndex from "./Routes/routeIndex"

//import Custom Style scss
import "./assets/scss/theme.scss";

function App() {
  return (
    <React.Fragment>
      <RouteIndex />
    </React.Fragment>
  );
}

export default App;
